export default __webpack_public_path__ + "static/soft_dreams-d233385be4be8b88ca0408e1799fc240.png";